import DateFilter from '@/components/date-filter';
import EnteteBonEtFacture from '@/components/en-tete-bon-facture';
import store_operation from "@/store/mods/caisse/operations"
import $ from 'jquery'

export default {
    name: 'coupons',
    components: {
        DateFilter, EnteteBonEtFacture
    },
    props: [],
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            liste_coupons: [],

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_loading: true,
            is_empty: false,

            total_coupon: 0,
            load_error: false,

            fields: [
                { key: 'ref', label: 'Référence' }, "date", 'auteur', 'titre',
                "patient", { key: 'libelle', label: 'Libellé' }, 'montant'
            ],
           
            filter: "",
            perPage: -1,
            print_per_page: -1,
            currentPage: 1,
            is_printing: false,
            filename: '',

            personnel: '',
            personnel_id: '',

            is_confirm: false,
            save_loading: false,
            can_print: false,
            is_month: false
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.operations_tobe_canceled = []
            const data = {
                user_id: this.personnel_id,
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: ""
            }
            this.current_date_filter = data

            this.is_month = true
            this.getCoupons(data)
        },

        personnel() {
            this.personnel_id = this.personnel.id
            const data = {
                user_id: this.personnel_id,
                month: this.current_date_filter.month,
                one_date: this.current_date_filter.one_date,
                from_date: this.current_date_filter.from_date,
                to_date: this.current_date_filter.to_date,
                is_all: false
            }
            this.getCoupons(data)
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        liste_personnel_roles() {
            return this.$store.getters["liste_personnel_roles"];
        },

        discount_observer() {
            return this.$store.getters["discount_observer"];
        },

        discount_number() {
            return this.$store.getters["discount_number"];
        },
    },

    mounted() {
        const tmpstamp = this.current_date.getHours()+''+this.current_date.getMinutes()+''+this.current_date.getFullYear()
        this.filename = 'Coupon_'+tmpstamp

        this.$store.dispatch("getRolePersonnels").then(() => {
            const all_user = {
				id: "",
				nom: 'Tous(tes) les caissiers(es)',
                titre: "",
                roles: [],
                email: ""
			}
			this.liste_personnel_roles.unshift(all_user)
        })

        const data = {
            user_id: this.personnel_id,
            month: "",
            one_date: this.setDates().today_date,
            from_date: "",
            to_date: "",
            is_all: false
        }
        this.current_date_filter = data
        this.getCoupons(data)

        
        this.countCoupon(data)
    },

    methods: {
        countCoupon(data) {
            this.$store.dispatch('countDiscount', data)
        },

        getCoupons(data) {
            this.is_loading = true
            this.load_error = false
            this.total_coupon = 0

            this.countCoupon(data)

            store_operation.getListeCoupons(data).then((coupons) => {
                this.liste_coupons = coupons
                if (this.liste_coupons.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false

                    this.liste_coupons.forEach(coupon => {
                        this.total_coupon += parseInt(coupon.montant)
                    });
                }
                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.load_error = true
            })
        },

        filterByDate(date) {
            const data = {
                user_id: this.personnel_id,
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
                is_all: false
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.is_month = false
            this.getCoupons(data)
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        validate(selector) {
            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé
                $('.err-msg').fadeIn(500)
                this.save_loading = false
                return
            }

            const data = {
                user_id: this.userCredentials.user.id,
                operations: this.liste_coupons
            }

            this.save_loading = true;
            this.$store.dispatch('updateViewedDiscount', data).then((response) => {
                if (response.success) {
                    this.successToast("Vérification de coupon effectuée avec succès.")
                    
                    this.is_confirm = false
                    this.$refs.confirm_discount.click();
                    this.$store.commit("SET_DISCOUNT_OBSERVER", (this.discount_observer == 0)?1:0);

                    this.countCoupon(this.current_date_filter)
                } else {
                    if (response.code == 204) {
                        this.warningToast("Une erreur s'est produite !")
                    } else if (response.code == 500) {
                        this.warningToast("Une erreur s'est produite !")
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.warningToast("Une erreur s'est produite !")
                this.save_loading = false
            })
        },

        printCoupon() {
            this.can_print = true

            setTimeout(() => {
                
                window.print()
                this.can_print = false
            }, 500);
        },
    }
}